import {
  // Edit,
  PlusCircle,
  Trash2,
  // ArrowUpLeft,
  // PlusSquare,
  Plus,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import { DeleteRequest, GetRequest, PostRequest } from "../../Api/ApiFunctions";
import { showSwalConfirmationAlert } from "../../Api/ConfirmationMessage";
import AssignAccount from "./AssignAccount";
import { message } from "antd";
// import { Plus } from "react-feather";

const EmployeeManagement = () => {
  const [dataSource, setDataSource] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const fetchData = async () => {
    setSelectedEmployee(null);
    const res = await GetRequest("empl");
    if (res) {
      setDataSource(res);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const EmployeeStatusChange = async (id, checkStatus) => {
    if (checkStatus) {
      const res = await PostRequest("empl/statuschange", {
        employeeId: id,
        active: true,
      });
      if (res) {
        message.success("User Is activated");
      }
    } else {
      const res = await PostRequest("empl/statuschange", {
        employeeId: id,
        active: false,
      });
      if (res) {
        message.warning("User Is Deactivated");
      }
    }
  };
  const DeleteUser = async (id) => {
    console.log("delete initiated", id);
    const res = await DeleteRequest(`empl/${id}`);
    if (res) {
      fetchData();
      message.success("Employee Deleted SuccessFully");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name?.length - b.name?.length,
    },
    {
      title: "SalesPerson - Key",
      dataIndex: "salesperson_name",
      sorter: (a, b) => a.salesperson_name?.length - b.salesperson_name?.length,
    },

    {
      title: "Accounts",
      dataIndex: "accounts",
      render: (_, record) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {record?.accounts?.map((it, i) => (
            <div
              key={it?.id}
              className="badge bg-outline-primary"
              style={{ whiteSpace: "nowrap" }}
            >
              {it?.account_name}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Active",
      dataIndex: "action",
      render: (_, record) => (
        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
          <input
            type="checkbox"
            id={record.id}
            className="check"
            defaultChecked={record?.active}
            onChange={(e) => EmployeeStatusChange(record.id, e.target.checked)}
          />
          <label htmlFor={record.id} className="checktoggle mb-0">
            {" "}
          </label>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            {/* <Link className="me-2 p-2" to={route.productdetails}>
              <Eye className="feather-view" />
            </Link> */}
            <a
              className="me-2 p-2"
              data-bs-toggle="modal"
              data-bs-target="#assign-account"
              onClick={() => setSelectedEmployee(record)}
            >
              <Plus className="feather-edit" />
            </a>
            <Link
              className="confirm-text p-2"
              onClick={() =>
                showSwalConfirmationAlert(() => DeleteUser(record.id))
              }
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Management</h4>
              <h6>Manage your Employees</h6>
            </div>
          </div>

          <div className="page-btn">
            <a
              to="#"
              className="btn btn-added"
              data-bs-toggle="modal"
              data-bs-target="#new-employee"
            >
              <PlusCircle className="me-2" />
              New Employee
            </a>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <AssignAccount
          FetchNewData={() => fetchData()}
          selectedEmployee={selectedEmployee}
        />
      </div>
    </div>
  );
};

export default EmployeeManagement;
